import React from 'react';

const AccessDeniedAlert = () => {

    const handleUserLogout = () => {
        window.location.pathname = '/dashboard';
    };

    return (
        <div
            className="modal show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body text-center p-4">
                        <img
                            src ={'/Assets/accessDeniedPage.png'}
                            alt="Access Denied"
                            style={{ width: "100%", height: "auto", marginTop: "4px" }}
                        />
                        <h4 className="text-danger mt-3">You do not have access to this page</h4>
                        <button
                            className="btn btn-primary mt-3"
                            onClick={() => handleUserLogout()}
                            key="ok"
                        >
                            Go to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccessDeniedAlert;
